/**
 * @desc unBind
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.Response;
export function request(snno: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierSn/unBind/${snno}`, {
      method: "POST",

      ...options,
    }),
  );
}
